import { FiltersFieldIds } from '@epicuro-next/models/order-book';
import { utcDateTime } from '@epicuro-next/utilities';

export const makeYearFilter = (range: [string, string]) => ({
  fieldId: FiltersFieldIds.DeliveryYear,
  value: utcDateTime(range[0]).year.toString(),
});
